// ---------- import external dependencies ---------
import React from "react";
import { ToastContainer } from "react-toastify";
// Add css file to allow toast display
import "react-toastify/dist/ReactToastify.css";

function Toaster() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        // transition="flip"
        rtl={false}
        pauseOnHover={false}
        role="alert"
        containerId={"toaster-id"}
      >
        {}
      </ToastContainer>
    </>
  );
}

export default Toaster;
